import React, {Fragment} from 'react';
import Header from '../components/structure/Header';
import Footer from '../components/structure/Footer';
import MainContainer from "../components/structure/MainContainer";
import Sidebar from "../components/structure/Sidebar";
import {connect} from 'react-redux';

class MainContainerLayout extends React.Component {

  render() {
    const { affiliates, clients} = this.props;

    return (
      <div className="wrapper">
          { affiliates && clients &&
              <Fragment>
                <Header/>
                <div className="wrapper-content">
                  <Sidebar/>
                  {affiliates.affiliatesList && clients.clientList && <MainContainer/>}
                </div>
                <Footer/>
              </Fragment>
          }
      </div>
    );
  }
}


const mapStateToProps = state => {

  const {affiliates, clients} = state;

  return {
    affiliates: affiliates,
    clients: clients
  };
};


export default connect(mapStateToProps)(MainContainerLayout);
